import React, { useCallback, useState } from "react";
import clsx from "clsx";

import { Select } from "../Select/Select";
import { useGlobalSearchContext } from "../../../../context/globalSearch.context";
import { ERequestState } from "../../../../types/RequestState";

export function SearchField({ toggleExpandBg }) {
	const [input, setInput] = useState("");

	const { handleSetSearchField, makeRequest, request } =
		useGlobalSearchContext();

	const handleOnChange = (e) => {
		const value = e.target.value;

		setInput(value);

		handleSetSearchField(value);
	};

	const handleEnterClick = useCallback(
		({ code }) => code === "Enter" && makeRequest(),
		[makeRequest]
	);

	return (
		<div
			className={clsx(
				"MuiGrid-root MuiGrid-container MuiGrid-item animate__animated",
				{
					animate__shakeX: request === ERequestState.EmptyResponse,
				}
			)}
		>
			<div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12">
				<div className="searchBoxContainer-8">
					<div className="MuiInputBase-root searchInput-12">
						<input
							type="text"
							autoFocus=""
							value={input}
							onInput={handleOnChange}
							onKeyUp={handleEnterClick}
							aria-label="naked"
							className="MuiInputBase-input"
						/>
					</div>

					<div className="separatorLine-16" style={{ marginTop: 8 }}></div>

					<Select toggleExpandBg={toggleExpandBg} />

					<div className="mainSeparatorLine-17"></div>
					<div className="searchButton-11" onClick={makeRequest}>
						<svg
							style={{ marginTop: -3 }}
							width="22"
							height="28"
							viewBox="0 0 28 28"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M20.2489 11.4382C20.2489 16.5008 16.1448 20.6048 11.0822 20.6048C6.01958 20.6048 1.91553 16.5008 1.91553 11.4382C1.91553 6.37554 6.01958 2.27148 11.0822 2.27148C16.1448 2.27148 20.2489 6.37554 20.2489 11.4382Z"
								stroke="white"
								strokeWidth="3"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M26 26L18 18"
								stroke="white"
								strokeWidth="3"
								strokeLinejoin="round"
							/>
						</svg>
					</div>
				</div>
			</div>
		</div>
	);
}
